import React from 'react'
import PropTypes from 'prop-types'
import PronosMarinoPuntoH from '../../components/pronostico-marino/PronosMarinoPuntoH'
import { Marker, Popup, Tooltip } from 'react-leaflet'
import useMediaQuery from '@mui/material/useMediaQuery'
import { useTheme } from '@mui/material/styles'

export default function MarkerPtoPronosMarino({
    lat,
    lng,
    nombrePuerto,
    serieDirViento,
    serieIntViento,
    serieIntRafaga,
    serieAltOla,
    serieDirOla,
    seriePeriodoOla,
    fechaInicio,
    horasPronostico,
    resolucionTemporalHoras,
    serieVisibilidad,
    serieTempAire,
    seriePrecipitacion,
    seriePresion,
    serieTotalCieloCubierto,
    onMarkerClick,
}) {
    const theme = useTheme()
    const mcel = useMediaQuery(theme.breakpoints.down('md'))

    return (
        <Marker position={[lat, lng]} eventHandlers={{ click: onMarkerClick }}>
            <Tooltip offset={[0, -20]}>
                <span>{nombrePuerto}</span>
            </Tooltip>
            <Popup
                minWidth={mcel ? 350 : 700}
                style={{ zIndex: 910 }}
                classname="custom-popup"
            >
                <p className="tituloInfoWindow">{nombrePuerto}</p>

                <PronosMarinoPuntoH
                    nombrePunto={nombrePuerto}
                    nombreSerie={nombrePuerto}
                    serieDirViento={serieDirViento}
                    serieIntViento={serieIntViento}
                    serieIntRafaga={serieIntRafaga}
                    seriePrecipitacion={seriePrecipitacion}
                    serieAltOla={serieAltOla}
                    seriePeriodoOla={seriePeriodoOla}
                    serieDirOla={serieDirOla}
                    serieVisibilidad={serieVisibilidad}
                    serieTempAire={serieTempAire}
                    seriePresion={seriePresion}
                    serieTotalCieloCubierto={serieTotalCieloCubierto}
                    fechaInicio={fechaInicio}
                    horasPronostico={horasPronostico}
                    resolucionTemporalHoras={resolucionTemporalHoras}
                />
            </Popup>
        </Marker>
    )
}

MarkerPtoPronosMarino.propTypes = {
    lat: PropTypes.number,
    lng: PropTypes.number,
    nombrePuerto: PropTypes.string,
    serieDirViento: PropTypes.array,
    serieIntViento: PropTypes.array,
    serieIntRafaga: PropTypes.array,
    serieAltOla: PropTypes.array,
    serieDirOla: PropTypes.array,
    seriePeriodoOla: PropTypes.array,
    serieVisibilidad: PropTypes.array,
    serieTempAire: PropTypes.array,
    seriePresion: PropTypes.array,
    seriePrecipitacion: PropTypes.array,
    serieTotalCieloCubierto: PropTypes.array,
    fechaInicio: PropTypes.object,
    horasPronostico: PropTypes.number,
    resolucionTemporalHoras: PropTypes.number,
    onMarkerClick: PropTypes.func,
}
